import { createContext } from "react";

const TextContext = createContext(null);

export default TextContext;